import { Routes } from '@angular/router';
import {CreatorLayoutComponent} from './layout/creator-layout/creator-layout.component';
import {AuthGuard} from '../core/guards/auth.guard';
import {DashboardComponent} from './pages/dashboard/dashboard.component';
import {LandingComponent} from './pages/landing/landing.component';
import {NonAuthGuard} from '../core/guards/non-auth.guard';
import {PhotographerGuard} from '../core/guards/photographer.guard';
import {PublicProfileComponent} from './pages/public-profile/public-profile.component';
import {ServicesComponent} from './pages/services/services.component';
import {BookingsComponent} from './pages/bookings/bookings.component';
import {BookingComponent} from './pages/booking/booking.component';
import {PayComponent} from './pages/pay/pay.component';
import {RegistrationDoneGuard} from '../core/guards/registration-done.guard';
import {CalendarComponent} from './pages/calendar/calendar.component';
import {Onboarding} from './pages/onboarding/onboarding';

export const routes: Routes = [
  { path: 'onboarding', component: Onboarding, canActivate: [AuthGuard, PhotographerGuard, RegistrationDoneGuard] },
  { path: '', component: LandingComponent, canActivate: [NonAuthGuard]},
  { path: '',
    component: CreatorLayoutComponent,
    canActivate: [AuthGuard, PhotographerGuard, RegistrationDoneGuard],
    children: [
      { path: 'bookings', component: BookingsComponent},
      { path: 'booking/:id', component: BookingComponent},
      { path: 'calendar', component: CalendarComponent},
      { path: 'dashboard', component: DashboardComponent},
      { path: 'public-profile', component: PublicProfileComponent},
      { path: 'services', component: ServicesComponent},
      { path: 'pay', component: PayComponent},
      { path: '**', redirectTo: 'dashboard'}
    ]
  },
  { path: '**', redirectTo: ''},
];
